import $ from 'gridstrap/lib/gs-zepto';
import * as config from './config';

export class GSShareButtons {
	private root;
	private buttons;

	constructor(root) {
		this.root = $(root);
		this.buttons = this.root.find('.gs-ShareButtons-button');
		this.buttons.on('click.shareButtons', evt => this.handleButtonClick(evt));
	}

	gsOnDestroy() {
		this.buttons.off('click.shareButtons');
	}

	//////////

	get url() { return this.getMetaValue('url', location.href.split('#')[0]); }
	get text() { return this.getMetaValue('text', this.title); }
	get title() { return this.getMetaValue('title', document.title); }
	get summary() { return this.getMetaValue('summary'); }
	get contentId() { return this.getMetaValue('content-id'); }
	get contentType() { return this.getMetaValue('content-type'); }

	//////////

	openPopupWindow(service) {
		const { endpoint, data } = config.services[service];
		const options = config.popupWindowOptions.join(',');
		const querystring = this.buildQuerystring(data);
		window.open(`${endpoint}?${querystring}`, 'SocialMediaShare', options);
	}

	private handleButtonClick(evt) {
		const button = $(evt.currentTarget);
		const service = button.data('gsShareButtonsService');
		this.openPopupWindow(service);
	}

	private buildQuerystring(data) {
		Object.keys(data).forEach(key => data[key] = this[key] || key);
		return $['param'](data);
	}

	private getMetaValue(key, defaultValue = '') {
		let tag = this.root.find(`meta.social[property="social-${key}"]`);
		return tag.attr('content') || defaultValue;
	}
}
